import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AccountService} from '../service/account.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiHasAnyAuthorityMenu="'METRICS'">...</some-element>
 *
 *     <some-element *jhiHasAnyAuthorityMenu="['METRICS', 'SUBSCRIPTIONS']">...</some-element>
 * ```
 */
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[jhiHasAnyAuthorityMenu]',
    standalone: false
})
export class HasAnyAuthorityMenuDirective {
    private menus: string[];

    constructor(private accountService: AccountService, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {
    }

    @Input()
    set jhiHasAnyAuthorityMenu(value: string | string[]) {
        this.menus = typeof value === 'string' ? [value] : value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.accountService.getAuthenticationState().subscribe(identity => this.updateView());
    }

    private updateView(): void {
        const hasAnyAuthority = this.accountService.hasAnyMenu(this.menus);
        this.viewContainerRef.clear();
        if (hasAnyAuthority) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
